import { render, staticRenderFns } from "./RevCardContainer.vue?vue&type=template&id=304874aa&scoped=true"
import script from "./RevCardContainer.vue?vue&type=script&lang=js"
export * from "./RevCardContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304874aa",
  null
  
)

export default component.exports